import { renderPage } from "renderPage"
import { AccountAlbumIndexPage } from "./Page"

renderPage({ component: AccountAlbumIndexPage })
